var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70636 7.00391L11.2952 2.72598C11.3554 2.65488 11.3048 2.54688 11.2118 2.54688H10.1208C10.0566 2.54688 9.99503 2.57559 9.95265 2.6248L6.99269 6.15352L4.03273 2.6248C3.99171 2.57559 3.93019 2.54688 3.86456 2.54688H2.77355C2.68058 2.54688 2.62999 2.65488 2.69015 2.72598L6.27902 7.00391L2.69015 11.2818C2.67667 11.2977 2.66803 11.3171 2.66524 11.3377C2.66245 11.3583 2.66564 11.3793 2.67442 11.3981C2.6832 11.417 2.69721 11.4329 2.71478 11.4441C2.73235 11.4552 2.75275 11.4611 2.77355 11.4609H3.86456C3.92882 11.4609 3.99034 11.4322 4.03273 11.383L6.99269 7.8543L9.95265 11.383C9.99366 11.4322 10.0552 11.4609 10.1208 11.4609H11.2118C11.3048 11.4609 11.3554 11.3529 11.2952 11.2818L7.70636 7.00391Z",
    fill: "#3A3A3A",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.827e9c97b3cacac5d94884bbece46fdc.svg";
export { ForwardRef as ReactComponent };